import { $addFields } from "./addFields";
/**
 * Alias for $addFields.
 */
export const $set = $addFields;
